module.exports = __webpack_public_path__ + "img/report.22a864f.png";